module.exports = __webpack_public_path__ + "static/media/company.3545d168.png";